import copyToClipboardIcon from '../../../images/icons/copy_to_clipboard.svg';
import checkIcon from '../../../images/icons/check_circle_outline.svg';

((Drupal, once) => {
  const LABEL_COPY = Drupal.t('Copy to clipboard');
  const LABEL_COPIED = Drupal.t('Copied');
  const FEEDBACK_TEXT = Drupal.t('Copied to clipboard');

  const copyText = async (value) => {
    if (!value) return;

    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return;
    }

    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  };

  Drupal.behaviors.veoliaCopyToClipboard = {
    attach(context) {
      once('veolia-copy-to-clipboard', '.js-input-copy-to-clipboard', context)
        .forEach((input) => {
          const value = input.dataset.copyValue || input.value || '';
          if (!value) return;

          if (input.closest('.copy-input-wrapper')) return;

          // wrapper
          const wrapper = document.createElement('div');
          wrapper.className = 'copy-input-wrapper';

          input.parentNode.insertBefore(wrapper, input);
          wrapper.appendChild(input);

          // button
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'copy-input-btn';
          btn.setAttribute('aria-label', LABEL_COPY);
          btn.setAttribute('title', LABEL_COPY);

          btn.innerHTML = `
            <span class="copy-anim" aria-hidden="true">
              <span class="copy-anim-icon copy-anim-icon--copy">
                ${copyToClipboardIcon}
              </span>
              <span class="copy-anim-icon copy-anim-icon--check">
                ${checkIcon}
              </span>
            </span>
          `;

          wrapper.appendChild(btn);

          // feedback
          const feedback = document.createElement('div');
          feedback.className = 'valid-feedback';
          feedback.textContent = FEEDBACK_TEXT;
          wrapper.insertAdjacentElement('afterend', feedback);

          // click
          btn.addEventListener('click', async () => {
            await copyText(value);

            btn.classList.add('is-copied');
            btn.setAttribute('title', LABEL_COPIED);
            btn.setAttribute('aria-label', LABEL_COPIED);

            input.classList.add('is-valid');
            feedback.style.display = 'block';

            setTimeout(() => {
              btn.classList.remove('is-copied');
              btn.setAttribute('title', LABEL_COPY);
              btn.setAttribute('aria-label', LABEL_COPY);

              input.classList.remove('is-valid');
              feedback.style.display = 'none';
            }, 1000);
          });
        });
    },
  };
})(Drupal, once);
